import { ACTION_TYPE } from '../constants/actionType'

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPE.showAddNFTDialog: {
      const { onAdd, onClose } = action.payload
      return { isShow: true, onAdd, onClose }
    }
    case ACTION_TYPE.hideAddNFTDialog: {
      return { isShow: false, onAdd: () => {}, onClose: () => {} }
    }
    default: {
      return state
    }
  }
}

const initialState = { isShow: false, onAdd: () => {}, onClose: () => {} }

const initialize = (initialState = {}) => initialState

const reducerArgs = [reducer, initialState, initialize]

export default reducerArgs
